import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dual-range-wrapper" }
const _hoisted_2 = { class: "values" }
const _hoisted_3 = { class: "slider-container" }
const _hoisted_4 = ["min", "max", "step", "value"]
const _hoisted_5 = ["min", "max", "step", "value"]

import { computed, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DualRangeSlider',
  props: {
    min: {},
    max: {},
    step: {},
    modelValue: {},
    unit: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Local state for smooth dragging
const lower = ref(props.modelValue[0]);
const upper = ref(props.modelValue[1]);

watch(
  () => props.modelValue,
  (val) => {
    lower.value = val[0];
    upper.value = val[1];
  }
);

function onInputLower(e: Event) {
  const val = Number((e.target as HTMLInputElement).value);
  // Prevent crossing
  if (val > upper.value) {
    lower.value = upper.value;
  } else {
    lower.value = val;
  }
  emit("update:modelValue", [lower.value, upper.value]);
}

function onInputUpper(e: Event) {
  const val = Number((e.target as HTMLInputElement).value);
  // Prevent crossing
  if (val < lower.value) {
    upper.value = lower.value;
  } else {
    upper.value = val;
  }
  emit("update:modelValue", [lower.value, upper.value]);
}

// Calculate percentages for the track background
const minPct = computed(() => {
  const range = props.max - props.min;
  return ((lower.value - props.min) / range) * 100;
});

const maxPct = computed(() => {
  const range = props.max - props.min;
  return ((upper.value - props.min) / range) * 100;
});

// Detect if labels would overlap (if handles are too close)
const labelsOverlap = computed(() => {
  return Math.abs(maxPct.value - minPct.value) < 20; // Less than 20% apart
});

// Smart positioning: stack labels vertically when they overlap
const lowerLabelStyle = computed(() => {
  if (labelsOverlap.value) {
    return {
      left: minPct.value + '%',
      top: '12px', // Position below slider
    };
  }
  return {
    left: minPct.value + '%',
    top: '12px',
  };
});

const upperLabelStyle = computed(() => {
  if (labelsOverlap.value) {
    return {
      left: maxPct.value + '%',
      top: '-32px', // Position above slider
    };
  }
  return {
    left: maxPct.value + '%',
    top: '12px', // Same level when not overlapping
  };
});

const trackStyle = computed(() => {
  return {
    background: `linear-gradient(to right, 
      #1b222b ${minPct.value}%, 
      #00b3b3 ${minPct.value}%, 
      #00b3b3 ${maxPct.value}%, 
      #1b222b ${maxPct.value}%)`
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["val-label lower", { stacked: labelsOverlap.value }]),
        style: _normalizeStyle(lowerLabelStyle.value)
      }, _toDisplayString(lower.value) + _toDisplayString(__props.unit), 7),
      _createElementVNode("span", {
        class: _normalizeClass(["val-label upper", { stacked: labelsOverlap.value }]),
        style: _normalizeStyle(upperLabelStyle.value)
      }, _toDisplayString(upper.value) + _toDisplayString(__props.unit), 7)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "track-bg",
        style: _normalizeStyle(trackStyle.value)
      }, null, 4),
      _createElementVNode("input", {
        type: "range",
        min: __props.min,
        max: __props.max,
        step: __props.step || 1,
        value: lower.value,
        onInput: onInputLower,
        class: _normalizeClass(["thumb thumb-zindex-3", { 'thumb-zindex-4': lower.value > __props.max - (__props.max-__props.min)/2 }])
      }, null, 42, _hoisted_4),
      _createElementVNode("input", {
        type: "range",
        min: __props.min,
        max: __props.max,
        step: __props.step || 1,
        value: upper.value,
        onInput: onInputUpper,
        class: "thumb thumb-zindex-4"
      }, null, 40, _hoisted_5)
    ])
  ]))
}
}

})